var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7496 28.7305C6.16863 28.7305 0 22.5621 0 14.9811C0 7.40008 6.16863 1.23145 13.7496 1.23145C16.3858 1.23145 18.9506 1.98261 21.1668 3.40507C21.6019 3.68521 21.7294 4.26518 21.4492 4.70141C21.1682 5.13765 20.5893 5.26376 20.1531 4.98385C18.2406 3.75502 16.0258 3.10639 13.7496 3.10639C7.20223 3.10639 1.87494 8.43367 1.87494 14.9811C1.87494 21.5283 7.20223 26.8556 13.7496 26.8556C20.2968 26.8556 25.6241 21.5283 25.6241 14.9811C25.6241 14.5897 25.6054 14.2022 25.5692 13.8212C25.5193 13.3048 25.8967 12.8473 26.4117 12.7974C26.9292 12.7498 27.3853 13.1249 27.4354 13.6399C27.4778 14.0812 27.4991 14.5286 27.4991 14.9811C27.4991 22.5621 21.3307 28.7305 13.7496 28.7305Z",
    fill: "#EC5F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.312 18.1061C15.0721 18.1061 14.832 18.0147 14.6496 17.8312L9.02477 12.2064C8.65857 11.8399 8.65857 11.2462 9.02477 10.88C9.39097 10.5138 9.98467 10.5138 10.3509 10.88L15.3133 15.8425L28.399 2.75658C28.7654 2.39038 29.3591 2.39038 29.7253 2.75658C30.0915 3.12278 30.0915 3.71648 29.7253 4.08268L15.9757 17.8323C15.7919 18.0147 15.552 18.1061 15.312 18.1061Z",
    fill: "#0BB8C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.e1a4063ece1b5638cc2038067fd2e996.svg";
export { ForwardRef as ReactComponent };